import type { ThemeProps } from './theme';

function hostnameFromUrl(url: string): string | null {
  try {
    return new URL(url).hostname;
  } catch {
    return null;
  }
}

export function triggerRedirectIfRequired(theme: Pick<ThemeProps, 'redirectToUrl' | 'website'>): void {
  const currentHost = window.location.hostname;

  if (currentHost.endsWith('localhost') || currentHost.endsWith('127.0.0.1')) {
    return;
  }

  if (theme.redirectToUrl) {
    const redirectHost = hostnameFromUrl(theme.redirectToUrl);

    if (!redirectHost || redirectHost === currentHost) {
      return;
    }

    window.location.href = theme.redirectToUrl;
    return;
  }

  if (!theme.website) {
    return;
  }

  const websiteHost = hostnameFromUrl(theme.website);

  if (!websiteHost || websiteHost === currentHost || `www.${websiteHost}` === currentHost) {
    return;
  }

  window.location.href = theme.website;
}

